module.exports = __webpack_public_path__ + "img/experiment_02b.597e15d7.jpg";